"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = map;

function map(values, mapper) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
  return Array.from(values, (value, index) => mapper(value, index, values));
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-array/src/map.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-array/src/map.js
// module chunks = 1